var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"legal-content text-sm"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.agreement.body)}}),_vm._v(" "),(_vm.updatedAt)?_c('div',{staticClass:"mt-4 pt-3"},[_vm._v("\n    "+_vm._s(_vm.updatedAt)+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }